// Copyright (c) 2017 Deere & Company

import SearchFilters from '../../../shared/state/search-filters';

export const getDefaultState = () =>
    new SearchFilters({
        filterBy: '',
        query: '',
        sortBy: ['requestDate'],
        sortDirection: 'DESC'
    });



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/state/search-filters.js